// Servicio de cache para columnas del Gantt
class ColumnCache {
  constructor() {
    this.cache = new Map();
    this.initialized = false;
  }

  // Inicializar eventos del Gantt que invalidan el cache
  initialize(gantt) {
    if (this.initialized) return;
    const events = [
      // Modificación de tareas
      'onAfterTaskAdd',
      'onAfterTaskUpdate',
      'onAfterTaskDelete',
      'onBeforeTaskDrag',
      'onAfterTaskDrag',
      'onBeforeTaskChanged',
      'onTaskCreated',
      'onBeforeTaskAdd',
      'onEditEnd',

      // Estructura
      'onRowDragEnd',
      'onAfterTaskMove',
      'onAfterSort',
      'onBeforeParse',
      'onParse',

      // Datos
      'onDataRender',
      'onGanttReady',
      'onBeforeGanttReady',

      // Otros eventos que pueden afectar las columnas
      'onTaskLoading',
      'onBeforeTaskDisplay',
      'onBeforeRedoStack',
      'onBeforeUndoStack',
      'onAfterBatchUpdate'
    ];

    events.forEach((eventName) => {
      gantt.attachEvent(eventName, () => {
        this.invalidateCache();
        return true; // Permitir que otros handlers se ejecuten
      });
    });

    this.initialized = true;
  }

  // Generar key única para el cache
  generateCacheKey(columnId, taskId) {
    return `${columnId}:${taskId}`;
  }

  // Obtener valor del cache
  get(columnId, taskId) {
    const key = this.generateCacheKey(columnId, taskId);
    return this.cache.get(key);
  }

  // Guardar valor en el cache
  set(columnId, taskId, value) {
    const key = this.generateCacheKey(columnId, taskId);
    this.cache.set(key, value);
  }

  // Verificar si existe un valor en el cache
  has(columnId, taskId) {
    const key = this.generateCacheKey(columnId, taskId);
    return this.cache.has(key);
  }

  // Invalidar todo el cache
  invalidateCache() {
    this.cache.clear();
    this.initialized = false;
  }

  // Invalidar cache para una columna específica
  invalidateColumn(columnId) {
    for (const key of this.cache.keys()) {
      if (key.startsWith(`${columnId}:`)) {
        this.cache.delete(key);
      }
    }
  }

  // Invalidar cache para una tarea específica
  invalidateTask(taskId) {
    for (const key of this.cache.keys()) {
      if (key.endsWith(`:${taskId}`)) {
        this.cache.delete(key);
      }
    }
  }
}

// Exportar una única instancia del cache
export const columnCache = new ColumnCache();
